import React, { createContext, useState, useEffect, useContext } from "react";
import { auth } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { getUserProfile, getOrganizationDetails } from "./firestoreService";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [organizationName, setOrganizationName] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // --- ✅ SIMPLIFIED LOGIC ---
          // It now just fetches the profile and sets the state.
          const profile = await getUserProfile(user.uid);

          if (profile && profile.organizationId) {
            const orgDetails = await getOrganizationDetails(
              profile.organizationId
            );
            setOrganizationName(orgDetails ? orgDetails.name : null);
          } else {
            setOrganizationName(null);
          }
          setCurrentUser(user);
          setUserRole(profile ? profile.role : null);
        } catch (error) {
          console.error("Auth context error:", error);
          setCurrentUser(null);
          setUserRole(null);
        } finally {
          setLoading(false);
        }
      } else {
        setCurrentUser(null);
        setUserRole(null);
        setOrganizationName(null);
        setLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole,
    organizationName,
    loading,
  };

  // Do not render the app until the initial loading is complete
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
